import React, { useEffect, useState, useRef } from 'react'
import { formatCurrency } from 'Utils'
import { Row, Col, Toast } from '@cleartrip/bento'
import { Divider } from '@cleartrip/bento/components/Divider'
import Overlay from 'Lib/Overlay'
import { CrossModal } from 'SVGPath/expressway'
import { getCurrencyByLocale } from 'AccountsUtils/transform'
import { checkUserLogin } from 'AccountsUtils'
import Warn from 'Lib/Status/icons/warning.svg'
import { apiGetHelper, checkMobileDevice, isInDomain, isInFlyinDomain, readCookie } from '../../../utils'
import { GET_WALLET_INFO, GET_WALLET_TRANSACTIONS, WALLET_TNC } from '../../../constants/api_endpoints'
import './index.scss'
import WalletDashboard from '../Wallet_flyin'

function Wallet({ domainFlyin = false }) {
  domainFlyin = isInFlyinDomain()
  const TNC_HEADER = 'Cleartrip Wallet T&C\'S'
  const BOOKING_TEXT = 'You\'ve made this booking by using your Cleartrip Wallet Credit balance which is stored in your Cleartrip Wallet in the form of a Gift Card.'
  const REFUND_TEXT = 'This refund amount has been added to your Cleartrip Wallet Credit balance as a gift card. You can use this balance towards any booking by selecting Cleartrip Wallet option during checkout.'
  const TOA_TEXT = 'Your Cleartrip wallet has been credited with a token amount of [amount]. You can use this balance towards any booking by selecting Cleartrip Wallet option during checkout.'
  const NO_TRANSACTION_TEXT = 'You don\'t have any transactions'
  const [transactions, setTransactions] = useState([])
  const [showTnCModal, setShowTnCModal] = useState(false)
  const [walletBalance, setWalletBalance] = useState(0)
  const [walletCurrency, setWalletCurrency] = useState(getCurrencyByLocale().currency)
  const [showLoadMore, setShowLoadMore] = useState(false)
  const [loadMoreText, setLoadMoreText] = useState('Load more transactions')
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [transactionsFetched, setTransactionsFetched] = useState(false)
  const [showLoginMessage, setShowLoginMessage] = useState(false)
  const [currentTransaction, setCurrentTransaction] = useState({})
  const [showGVdetails, setShowGVdetails] = useState(false)
  const offsetRef = useRef({
    offset: 1,
    pageSize: 10
  })

  const loadTripDetails = tripId => {
    window.location.href = `/accounts/trips/${tripId}`
  }

  const crossTnCModal = () => {
    setShowTnCModal(false)
  }

  const getTransactionAmount = (amt, type, currency) => {
    const tableValue = formatCurrency(amt, currency)
    if (type === 'CREDIT') {
      return tableValue
    }
    return `- ${tableValue}`
  }

  const getTransactionEvent = (eventName = '', walletType = '') => {
    if (eventName.toLowerCase() === 'expiration' && walletType.toLowerCase() === 'reward') {
      return 'Reward balance expired'
    } if (eventName.toLowerCase() === 'expiration' && walletType.toLowerCase() === 'credit') {
      return 'Credit balance expired'
    }
    let eventArr = eventName.split('_')
    eventArr = eventArr.map(event => event.toLowerCase())
    eventArr = eventArr.map(event => event[0].toUpperCase() + event.slice(1))
    const eventStr = eventArr.join(' ')
    return eventStr
  }

  const getTransactionMessage = (status = '') => {
    if (status === 'BOOKED') {
      return BOOKING_TEXT
    } if (status === 'Wallet Credit') {
      return TOA_TEXT.replace('[amount]', formatCurrency(currentTransaction.amount, 'INR'))
    }
    return REFUND_TEXT
  }

  const getTransactionDate = (date = '') => {
    return date.replaceAll('-', ' ')
  }

  const fetchTnC = async () => {
    try {
      const res = await apiGetHelper(`${WALLET_TNC}`)
      setShowTnCModal(true)
      if (res.data) {
        document.getElementById('tncPopUp').innerHTML = res.data
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  }

  const fetchWalletInfo = async () => {
    const userIdCookie = readCookie('userid')
    const userId = decodeURIComponent(userIdCookie).split('|')[4]
    const defaultCurObj = getCurrencyByLocale()
    const utmCurr = readCookie('utm_currency')
    const defaultCurrency = (utmCurr && utmCurr.split('|')[0]) || defaultCurObj.currency || ''

    const res = await apiGetHelper(`${GET_WALLET_INFO}?userId=${userId}&currency=${defaultCurrency}`)
    if (res.status === 200) {
      const { data: resData } = res
      if (Number.isInteger(Math.ceil(resData.balance))) {
        setWalletBalance(resData.balance)
        setWalletCurrency(resData.currency)
      }
    } else if (res &&
      res.error &&
      res.error.response &&
      res.error.response.status &&
      res.error.response.status !== 404) {
      setShowError(true)
      setErrorMessage('Unable to fetch details! Please try again.')
    }
  }

  const fetchWalletTransactions = async () => {
    const userIdCookie = readCookie('userid')
    const userId = decodeURIComponent(userIdCookie).split('|')[4]
    const defaultCurObj = getCurrencyByLocale()
    const utmCurr = readCookie('utm_currency')
    const defaultCurrency = (utmCurr && utmCurr.split('|')[0]) || defaultCurObj.currency || ''

    const res = await apiGetHelper(`${GET_WALLET_TRANSACTIONS}${userId}/transactions?offset=${offsetRef.current.offset}&size=${offsetRef.current.pageSize}&currency=${defaultCurrency}`)
    if (res.status === 200) {
      const { data: resData, headers } = res

      if (resData) {
        setTransactions(transactions.concat(resData))
      }
      if (Number(headers.remainingtransactioncount) === 0) {
        setShowLoadMore(false)
      } else {
        setShowLoadMore(true)
        offsetRef.current.offset += offsetRef.current.pageSize
      }
      setLoadMoreText('Load more transactions')
    } else if (res &&
      res.error &&
      res.error.response &&
      res.error.response.status &&
      res.error.response.status !== 404) {
      setShowError(true)
      setErrorMessage('Unable to fetch details! Please try again.')
    }
    setTransactionsFetched(true)
  }

  const loadMoreTransactions = () => {
    setLoadMoreText('loading...')
    fetchWalletTransactions()
  }

  const handleGVdetailClick = () => {
    setShowGVdetails(show => !show)
  }

  const setSelectedTransaction = transaction => {
    setCurrentTransaction(transaction)
    handleGVdetailClick()
  }

  const getHostname = () => {
    return window.location.hostname
  }

  const openHostPage = () => {
    window.location.href = `https://${getHostname()}`
  }

  const getTransactionsTable = () => {
    return (
      <div>
        <If condition={Array.isArray(transactions) && transactions.length > 0}>
          <div className="ml-4 mr-4 mt-4 fs-2 bg-grey-f1 bb bb-light-grey-color pt-1 pb-1 pr-1 pl-1 c-grey-555">
            <Row>
              <Col span={4}>
                Date
              </Col>
              <Col span={10}>
                Transaction details
              </Col>
              <Col span={6}>
                Event
              </Col>
              <Col span={4}>
                Amount
              </Col>
            </Row>
          </div>
          {
            transactions.map(transaction => {
              return (
                <div className="ml-4 mr-4 pl-1 pr-1 pt-1 bb bb-light-grey-color c-grey-444" style={{ height: '40px', fontSize: '12px' }}>
                  <Row>
                    <Col span={4}>
                      {getTransactionDate(transaction.date)}
                    </Col>
                    <Col span={10}>
                      <div style={{ maxHeight: '12px', overflow: 'hidden' }}>

                        {transaction['trip-details']}
                      </div>
                      {
                        transaction['trip-ref'] && (
                          <div className="fs-1 flex flex-left pt-1 c-grey-555">
                            <div>Trip ID: </div>
                            <div
                              className="c-blue c-pointer"
                              onClick={() => loadTripDetails(transaction['trip-ref'])}
                            >
                              {` ${transaction['trip-ref']}`}
                            </div>
                          </div>
                        )}
                    </Col>
                    <Col span={6}>
                      <div>
                        {getTransactionEvent(transaction.event, transaction.walletType)}
                      </div>
                      <div>
                        {transaction['expiry-date'] && (
                          <div className="fs-1 pt-1 c-grey-555">
                            Validity : {getTransactionDate(transaction['expiry-date'])}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col span={4}>
                      <div className="flex flex-left">
                        {getTransactionAmount(transaction.amount, transaction['txn-type'], transaction.currency)}
                      </div>
                      {transaction.walletGiftCardTxns &&
                        transaction.walletGiftCardTxns.length > 0 && (
                        <div
                          className="c-blue fw-600 fs-10 c-pointer mt-1"
                          onClick={() => setSelectedTransaction(transaction)}
                        >
                            Know more
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              )
            })
          }
          {
            showGVdetails && (
              <Overlay>
                <div className="minH-300 bg-white w-585 pr-4 pl-4 pt-4 pb-4 br-8">
                  <div className="flex flex-right c-pointer" onClick={handleGVdetailClick}>
                    <CrossModal />
                  </div>
                  <div className="fw-600 fs-24">
                    {currentTransaction['trip-details']}
                  </div>
                  <div className="bg-disabled br-8 pt-3 fs-3 fw-400 pt-4 pb-4 pr-4 pl-4 mt-3">
                    {getTransactionMessage(currentTransaction.event)}
                  </div>
                  <div className="fs-16 flex flex left mt-6 fw-500">
                    <div className="bento-c-neutral-500">Trip ID: </div>
                    <div className="ml-1">{currentTransaction['trip-ref']}</div>
                  </div>
                  {
                    currentTransaction.walletGiftCardTxns.map(txn => (
                      <div className="flex flex-between c-grey-777 fs-12 pt-3">
                        <div>
                          Gift card ID: {txn.giftCard}
                        </div>
                        <div>
                          {formatCurrency(txn.amount)}
                        </div>
                      </div>
                    ))
                  }
                  <Divider className="mt-4 bb" />
                  {
                    currentTransaction['expiry-date'] && (
                      <>
                        <div className="fs-12 flex flex left mt-4 mb-4 fw-500">
                          <div className="c-grey-777">Expires on: </div>
                          <div className="ml-1">{currentTransaction['expiry-date']}</div>
                        </div>
                      </>
                    )}
                </div>
              </Overlay>
            )}

          {
            showLoadMore && (
              <div className="c-blue pt-1 pb-4 fs-3 ml-4 c-pointer" onClick={loadMoreTransactions}>{loadMoreText}</div>
            )
          }
          <Else />
          <div className="ml-4 mt-2 fs-2 c-grey-888">
            {NO_TRANSACTION_TEXT}
          </div>
        </If>
      </div>
    )
  }

  useEffect(() => {
    if (checkUserLogin()) {
      if (!domainFlyin) {
        fetchWalletInfo()
        fetchWalletTransactions()
      }
    } else {
      setShowLoginMessage(true)
    }
  }, [domainFlyin])

  if (domainFlyin) {
    return <WalletDashboard />
  }

  return (
    <>
      <If condition={showLoginMessage}>
        <div className="flex flex-center fs-25 w-100p mt-8">
          <Warn fill="#c30" width="36px" height="36px" />
          <div className="pt-2 ml-2">
            Please log in to check your wallet details
          </div>
        </div>
        <Else />
        <div className="flex flex-left">
          <div
            style={{ minWidth: checkMobileDevice() ? '0px' : '640px' }}
            className="box-4"
          >

            <div className="bg-blue-wallet flex flex-between">
              <div className="c-white pt-5 pb-5 pl-4 fs-5">
                Current balance in your wallet
              </div>
              <div className="c-white pr-4 fs-5 pt-5 pb-5">
                {formatCurrency(walletBalance, walletCurrency)}
              </div>
            </div>
            <div>
              <div className="fs-5 pt-3 c-grey-555 pl-4">
                Transaction history
              </div>
              <If condition={transactionsFetched}>
                {getTransactionsTable()}
                <Else />
                <div className="flex flex-center">
                  <div className="Pageloader__spinner" />
                </div>
              </If>
            </div>
            {showTnCModal && (
              <Overlay>
                <div className="bg-white h-500 w-1150 pt-10 pl-10 pr-10">
                  <div className="flex flex-right">
                    <div onClick={crossTnCModal} className="c-pointer">
                      <CrossModal />
                    </div>
                  </div>
                  <div id="tncPopUp">
                    <div className="flex flex-center fs-12 c-grey-444 pt-12">
                      loading...
                    </div>
                  </div>
                </div>
              </Overlay>
            )}
            {
              showError &&
              <Toast message={errorMessage} onClose={() => setShowError(false)} className="row mt-15 ml-5 w-585 walletErrorToast" closeBtn={true} error={true} />
            }
          </div>
          <div className="bg-grey-f9 p-4" style={{ width: '270px', height: '350px' }}>
            <div className="fs-3 c-grey-888">{TNC_HEADER}</div>
            <div className="fs-2 c-grey-777 fw-500">
              <div className="flex flex-left">
                <div className="fs-40 lh-0">.</div>
                <div className="pt-1 pl-1">By selecting Cleartrip Wallet you have agreed to park money in your Cleartrip Account as a prepaid balance, and can be used only for bookings of Flights or Hotels at <span className="c-blue c-pointer" onClick={openHostPage}> {getHostname()}. </span></div>
              </div>
              <div className="flex flex-left"> <div className="fs-40 lh-0">.</div>
                <div className="pt-1 pl-1">Cleartrip will not accept any dispute on the transactions wherein the refund is processed in Cleartrip Wallet. The customer should contact Cleartrip customer support for further assistance.</div>
              </div>
              <div className="flex flex-left">
                <div className="fs-40 lh-0">.</div>
                <div className="pt-1 pl-1">The Cleartrip Wallet can be used only for the online transactions.</div>
              </div>
              <div className="flex flex-left"><div className="fs-40 lh-0">.</div>
                <div className="pt-1 pl-1">The balance in Cleartrip Wallet account shall not be refunded in any circumstances.</div>
              </div>
            </div>
            <div className="fs-2 c-grey-777 fw-500">
              <If condition={isInDomain()}>
                <a
                  href={`${window.location.origin}/terms/ct-wallet`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="c-blue mr-1"
                > Click here
                </a>
                <Else />
                <span className="c-blue c-pointer" onClick={fetchTnC}>Click here</span>
              </If>
              to read the all Terms & Conditions
            </div>
          </div>
        </div>
      </If>
    </>

  )
}

export default Wallet
